export const SHOW_TOASTER = 'app/SHOW_TOASTER';
export const RESET_TOASTER = 'app/RESET_TOASTER';
